// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
//
// <div data-controller="faq">
//   ...
// </div>

import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["searchInput", "item", "category", "question", "answer"]

  connect() {
    this.setupSearch();
    this.setupSmoothScroll();
    this.setupAccordion();
  }

  setupSearch() {
    const searchInput = this.searchInputTarget;
    if (!searchInput) return;

    searchInput.addEventListener('input', this.filterFaq.bind(this));
  }

  filterFaq(event) {
    const searchTerm = event.target.value.toLowerCase().trim();
    
    this.categoryTargets.forEach(category => {
      let hasVisibleItems = false;
      const items = category.querySelectorAll('[data-faq-target="item"]');
      
      items.forEach(item => {
        const questionEl = item.querySelector('[data-faq-target="question"]');
        const answerEl = item.querySelector('[data-faq-target="answer"]');
        
        const questionText = questionEl ? questionEl.textContent.toLowerCase() : '';
        const answerText = answerEl ? answerEl.textContent.toLowerCase() : '';
        
        if (questionText.includes(searchTerm) || answerText.includes(searchTerm) || searchTerm === '') {
          item.style.display = 'block';
          hasVisibleItems = true;
          
          // Expande o item se houver busca
          if (searchTerm !== '') {
            const collapse = item.querySelector('.collapse');
            if (collapse && !collapse.classList.contains('show')) {
              collapse.classList.add('show');
              const questionBtn = item.querySelector('.faq-question');
              if (questionBtn) {
                questionBtn.setAttribute('aria-expanded', 'true');
              }
            }
          }
        } else {
          item.style.display = 'none';
        }
      });

      // Mostra/esconde categoria baseado nos itens visíveis
      const categoryHeader = category.querySelector('.faq-category-header');
      if (categoryHeader) {
        categoryHeader.style.display = hasVisibleItems ? 'flex' : 'none';
      }
    });
  }

  setupSmoothScroll() {
    const quickLinks = this.element.querySelectorAll('.quick-link-card');
    
    quickLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href');
        if (targetId && targetId.startsWith('#')) {
          const targetElement = document.getElementById(targetId.substring(1));
          
          if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      });
    });
  }

  setupAccordion() {
    const questions = this.element.querySelectorAll('.faq-question');
    
    questions.forEach(question => {
      question.addEventListener('click', (e) => {
        const targetId = question.getAttribute('data-target');
        if (!targetId) return;
        
        const targetElement = document.querySelector(targetId);
        if (!targetElement) return;
        
        const isExpanded = question.getAttribute('aria-expanded') === 'true';
        
        // Toggle collapse
        if (isExpanded) {
          targetElement.classList.remove('show');
          question.setAttribute('aria-expanded', 'false');
        } else {
          targetElement.classList.add('show');
          question.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  // Action para busca
  search(event) {
    this.filterFaq(event);
  }

  // Action para navegação rápida
  scrollTo(event) {
    event.preventDefault();
    const targetId = event.currentTarget.getAttribute('href');
    if (targetId && targetId.startsWith('#')) {
      const targetElement = document.getElementById(targetId.substring(1));
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  // Action para toggle do accordion
  toggle(event) {
    const question = event.currentTarget;
    const targetId = question.getAttribute('data-target');
    if (!targetId) return;
    
    const targetElement = document.querySelector(targetId);
    if (!targetElement) return;
    
    const isExpanded = question.getAttribute('aria-expanded') === 'true';
    
    if (isExpanded) {
      targetElement.classList.remove('show');
      question.setAttribute('aria-expanded', 'false');
    } else {
      targetElement.classList.add('show');
      question.setAttribute('aria-expanded', 'true');
    }
  }
}
